import { createMandatoryContext } from 'contexts/utils';
import { PartnerAccount } from 'types';
import { PartnerContent } from 'types/Partner';
import { StateSetter } from 'types/utils/React';

interface PartnerPublicationsContextProps {
  contents: PartnerContent[];
  partnerAccount: PartnerAccount;
  setContents: StateSetter<PartnerContent[]>;
  setSelectedContent: StateSetter<PartnerContent | undefined>;
}

const partnerPublicationsContext =
    createMandatoryContext<PartnerPublicationsContextProps>(),
  [usePartnerPublicationsContext, PartnerPublicationsContextProvider] =
    partnerPublicationsContext;

export { usePartnerPublicationsContext, PartnerPublicationsContextProvider };
